module.exports = __webpack_public_path__ + "media/images/close_icon_u73-042c1cdc3f36fadda5c6100c7626c270.svg";